export default __webpack_public_path__ + "static/media/products-6-m.8c10ca59.webp";